import { gql } from 'graphql-request';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      name
      surname
      fullName
      email
      profilePictureLocation
    }
  }
`;

export const ME_SHELF_QUERY = gql`
  query MeShelf {
    me {
      id
      shelf {
        addedAt
        removedAt
        coffee {
          ...ShelfCoffee
        }
      }
      shelfHistory {
        addedAt
        removedAt
        coffee {
          ...ShelfCoffee
        }
      }
    }
  }

  fragment ShelfCoffee on Coffee {
    id
    name
    origin
    imageUrl
    isOnShelf
    roaster {
      id
      name
      location
      city
      countryCode
    }
  }
`;
